export const status = {
  FINISHED: '완료함',
  ONGOING: '진행중',
  NOT_STARTED: '시작안함',
};
